import Button, { ButtonTypes } from './Buttons/Button';
import { Group, Text } from '@mantine/core';
import { closeAllModals, openModal } from '@mantine/modals';

import { messages } from '@/consts/Messages';
import { mixpanelTrack } from '@/utils/mixpanel';
import { redirectToOneIdPage } from '@/utils/utils';
import { startTransition } from 'react';
import themeVariables from '@/styles/themeVariables';

const ConfirmationPopup = {
  confirm: (text, handleOk, loading?: boolean) => {
    openModal({
      size: 400,
      zIndex: 3000,
      withCloseButton: false,
      centered: true,
      children: (
        <div data-autofocus>
          {typeof text === 'string' ? (
            <Text
              weight={600}
              color={themeVariables.fontColors.medium}
              size={16}
              p={10}
            >
              {text}
            </Text>
          ) : (
            text
          )}
          <Group spacing={4} mt={30} position={'right'}>
            <Button
              type={ButtonTypes.gray}
              onClick={() => {
                closeAllModals();
              }}
            >
              취소
            </Button>
            <Button
              type={ButtonTypes.solidColored}
              loading={loading}
              onClick={async () => {
                await handleOk();
                if (!loading) {
                  closeAllModals();
                }
              }}
            >
              확인
            </Button>
          </Group>
        </div>
      ),
    });
  },
  login: (text: string = messages.NEEDS_LOGIN) => {
    openModal({
      size: 400,
      zIndex: 3000,
      withCloseButton: false,
      centered: true,
      children: (
        <div data-autofocus>
          <Text
            weight={600}
            color={themeVariables.colors.light500}
            size={16}
            p={10}
          >
            {text}
          </Text>
          <Group spacing={4} mt={30} position={'right'}>
            <Button
              type={ButtonTypes.gray}
              onClick={() => {
                closeAllModals();
              }}
            >
              취소
            </Button>
            <Button
              type={ButtonTypes.solidColored}
              onClick={() => {
                closeAllModals();
                redirectToOneIdPage();
                startTransition(() => mixpanelTrack('LoginPage', 'Viewed'));
              }}
            >
              로그인
            </Button>
          </Group>
        </div>
      ),
    });
  },
};

export default ConfirmationPopup;
